<script setup lang="ts">
import ArticleLawyersSection from '@/pages/journalArticle/ui/ArticleLawyersSection.vue';

import type { ArticleLawyersSection as SectionData } from '@/pages/journalArticle/model/types/articleLawyers';

defineProps<{
  lawyersSections: SectionData[];
}>();
</script>

<template>
  <ul class="article-lawyers-sections">
    <li
      v-for="section in lawyersSections"
      :key="section.categoryId"
      class="article-lawyers-sections__item"
    >
      <ArticleLawyersSection
        :lawyers="section.lawyers"
        :catalog-link="section.catalogLink"
        :category-id="section.categoryId"
      />
    </li>
  </ul>
</template>

<style lang="less">
.article-lawyers-sections {
  .flex-column(@size-x10);

  &__item:not(:last-child) {
    padding-bottom: @size-x10;
    border-bottom: 1px solid @color-gallery;
  }
}
</style>
